<template>
  <div>
    <div>
      <el-input
        placeholder="资源名称"
        v-popover:resourcePopover
        suffix-icon="el-icon-arrow-down"
        @input="houseChange"
        clearable
        @change="clearData"
        v-model="resourceName"
      ></el-input>

      <el-popover
        placement="bottom-start"
        popper-class="resource_drop__tree"
        ref="resourcePopover"
        v-model="popVisible"
        @show="isNotChangeProject = true"
        trigger="click"
      >
        <crm-resource-tree
          :project-id="projectId"
          :project-name="projectName"
          v-model="resource"
          @input="resourceChange"
          v-if="projectId && isNotChangeProject && !resourceName"
        ></crm-resource-tree>

        <el-table
          :data="resourceData"
          stripe
          highlight-current-row
          @current-change="handleCurrentChange"
          v-if="projectId && isNotChangeProject && resourceName && isCheckVisible"
          style="width: 100%">
          <el-table-column prop="name" label="资源名称" width="180">
            <template slot-scope="scope">
              <div>
                <span class='cursor-pointer underline' @click="choiceData(scope.row)">{{scope.row.name}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-alert title="请先选择项目" type="warning" :closable="false"
          show-icon v-if="!projectId"></el-alert>
      </el-popover>




    </div>
  </div>
</template>

<script>
  import CrmResourceTree from "@/components/resource/CrmResourceTree";
  import {COMMON_PROJECT_RESOURCE_PARAMS_LIST} from "@/store/mutation-types";

  export default {
  name: "CrmResourceDropTree",
  data() {
    return {
      resource: "",
      isNotChangeProject: true,
      resourceName: "",
      popVisible: false,
      isCheckVisible:true,
      resourceData:[],
    };
  },
  props: {
    projectId: {
      type: [String, Number],
      default: ""
    },
    projectName: {
      type: String,
      default: ""
    },
    holderText: {
      type: String
    }
  },
  methods: {
    resourceChange(data) {
      this.resourceName = data.name;
      this.popVisible = false;
      this.isCheckVisible = true;
      this.$emit("input", data);
    },
    async houseChange(data) {
      // 直接输入的change
      if(!data){
        return;
      }
      let params = {
        projectId: this.projectId,
        name: data,
      }
      this.isCheckVisible = true;
      this.resourceData = await this.$store.dispatch(COMMON_PROJECT_RESOURCE_PARAMS_LIST, params);
      console.log(this.resourceData);

      // this.$emit("input", { name: data, resourceId: "" });
    },
    handleCurrentChange(){
    },
    choiceData(row){
      this.resourceName = row.name;
      this.isCheckVisible = false;
      this.$emit("input", row);
    },
    clearData(){
      let params = {
        name:'',
        resourceId:'',
      }
      if(!this.resourceName){
        this.$emit("input", params);
      }
    }
  },
  components: {
    CrmResourceTree
  },
  watch: {
    projectId() {
      this.isNotChangeProject = false;
      // this.isCheckVisible = false,
      this.popVisible = false;
      this.resourceName = "";
    }
  }
};
</script>

<style>
.resource_drop__tree {
  resize: horizontal;
  overflow: hidden;
  width: 300px;
}
</style>
